import { UIRouter, Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { resolveStateParams } from '../global/resolves/params.resolve';
import { GiftComponent } from './gift/gift.component';

export const STATES: Ng2StateDeclaration[] = [
  {
    name: 'main.microsites',
    abstract: true
  },
  {
    name: 'main.microsites.gift',
    url: '/gift?code',
    views: {
      '$default@': { component: GiftComponent }
    },
    resolve: [
      resolveStateParams
    ],
    params: {
      header: {
        hideBackButton: true
      }
    }
  }
];


// WEBPACK FOOTER //
// ./src/app/microsites/microsites.states.ts